<div class="math-input-container">
  <div class="input-row">
    <span class="param-label">{{ param() }} =</span>
    <input type="number" class="value-input" [formControl]="inputCtrl" [step]="step()" />
  </div>
  @if (inputCtrl.invalid && inputCtrl.touched) {
    <div class="error-message">
      @if (inputCtrl.errors?.['required']) {
        Value is required
      } @else if (inputCtrl.errors?.['min']) {
        Value must be at least {{ min() }}
      } @else if (inputCtrl.errors?.['max']) {
        Value must be at most {{ max() }}
      }
    </div>
  }
</div>
